import { useP360Access } from 'partner360/hooks/access/useP360Access'

import { RetailAccessDenied } from './components/retailAccessDenied/RetailAccessDenied'
import { UamAccessDenied } from './components/uamAccessCheck/components/uamAccessDenied/UamAccessDenied'

export const P360Access = () => {
  const { isAccessDeniedRetail } = useP360Access()

  if (isAccessDeniedRetail) {
    return <RetailAccessDenied />
  }
  return <UamAccessDenied />
}
